import QuantitySelector from "@/components/cart/QuantitySelector"
import Button from "@/components/core/Button/Button"
import { singleSliderSettings } from "@/components/Default/CarouselSlick/v1/SlickSettings"
import DisplayDiscountPrice from "@/components/Shared/DisplayDiscountPrice"
import {
  addAnalyticsForSlider,
  addAnalyticsForNavigateToPDP,
} from "@/components/Shared/UpsellInstallServices/analytics"
import styles from "@/components/Shared/UpsellInstallServices/index.module.scss"
import Style from "@/components/Shared/UpsellInstallServices/RequiredProductItem/index.module.scss"
import { getConfig } from "@/constants/config"
import useWindowResize from "@/hooks/useWindowResize"
import { getUserPersona } from "@/utils/helper"
import { getPresetUrl, getRowCols } from "@/utils/index"
import React, { useEffect, useState } from "react"
import Slider from "react-slick"
import _isEmpty from "lodash/isEmpty"
import _get from "lodash/get"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import { addToCart } from "@/components/ProductDetail/v3/AddToCart/utils"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/Shared/UpsellInstallServices/localization"
import { getPDPUrlForProductTile } from "@/utils/helper"
import { NumericFormat } from "react-number-format"

const UpsellServicesMobile = props => {
  const {
    upSellData,
    slickRef,
  } = props
  const persona = getUserPersona() ?? "GST"
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  const [width] = useWindowResize()
  const [tileUrls, setTileUrls] = useState({});
  const slickSettings = singleSliderSettings(
    (_, current) => {},
    0,
    false,
    500,
    label => {
      staticText.arrowLabel = label
    },
    false,

    currentIndexAfterChange => {
      const currentSlideServiceData = upSellData[eval(currentIndexAfterChange)]
      if (!isSearchClick) {
        addAnalyticsForArrows(
          staticText.arrowLabel,
          currentSlideServiceData,
          currentIndexAfterChange,
          persona,
          staticText.serviceAvailableTitleUpSell,
          staticText.recommendationTitle
        )
      }
    }
  )
  const [currency, setCurrencySign] = useState("")
  const [skuPrependName, setSkuPrependName] = useState("")
  const [isMobile, setIsMobile] = useState(width <= 1203)

  useEffect(() => {
    checkSkuKPrepend()
    callToConfiguration()
    
const el = document.querySelector('.required-item');

let scrollTimeout;

el.addEventListener('scroll', () => {
  clearTimeout(scrollTimeout);

  scrollTimeout = setTimeout(() => {
   addAnalyticsForSlider()
  }, 200);
});

}, [])

  useEffect(() => {
  if (!upSellData?.length) return;

  upSellData.forEach((item) => {
    getPDPUrlForProductTile(item, item.sku_s).then((ret) => {
      setTileUrls((prev) => ({
        ...prev,
        [item.sku_s]: `${ret}?skuId=${item.sku_s}`
      }));
    });
  });
}, [upSellData]);


  useEffect(() => {
    setIsMobile(width <= 1024)
  }, [width])
  const callToConfiguration = async () => {
    const config = await getConfig()
    const { general: { siteName = "kohler" } = {} } = config ?? {}
    const currency = _get(config, "internationalization.currencySign", "")
    setCurrencySign(currency)
  }

  const checkSkuKPrepend = async () => {
    const { apiEndpoints: { skuPrepend = "" } = {} } = (await getConfig()) ?? {}
    setSkuPrependName(skuPrepend)
  }

  slickSettings["infinite"] = false
  

  return (
    <>
      <div className={styles.upsellmodal}>
        <div className="upsell-modal-header__title mb-20">
            {"Make It a Perfect Match"}
          </div>
          <div className="upsell-modal-header__text">
            {"Thoughtfully paired products customers usually choose together"}
          </div>
        <div className="upsell-modal-header">
          <Slider ref={slickRef} {...slickSettings}>
            <React.Fragment>
              <div className={`upsell-modal__container no-margin`}>
                <div className="right-side no-line">
                  <div className="required-parts-right-side">
                    <div className="required-item-header">
                      <div
                        className={`required-item recommended-item`}
                      >
                        <div className="required-item-list required-item-gap">
                          {upSellData
                            ? upSellData?.map((item, upSellDataIndex) => {
                                const productVariantImages = item[
                                  "productImages.labelWithUrl_s"
                                ]
                                  ? [item["productImages.labelWithUrl_s"]]
                                  : item["productImages.labelWithUrl_ss"] || []
                                const variantImages =
                                  productVariantImages.filter(
                                    img =>
                                      item.sku_s === img.split("|")[0]
                                  )
                                const imgUrl = variantImages && variantImages.length > 0 && variantImages[0].split("|")[5]
                                const {
                                  sku_s: skuId = "",
                                  ProductBrandName_s: productBrandName = "",
                                  productName_s: productName = "",
                                  [`Color.${persona}.Details_ss`]:
                                    colorPricing = "",
                                } = item
                                const selSkuDetails = colorPricing.find(ele => {
                                    return ele.split("|")[0] === item.sku_s
                                  })
                                const productPrice = selSkuDetails?selSkuDetails.split("|")[2]||0: 0
                                const discountedPrice = selSkuDetails?selSkuDetails.split("|")[3] || 0:0
                                return (
                                  <React.Fragment key={item.sku_s}>
                                    <a
                                      className={Style.requireditem}
                                      style={{ width: "100%", cursor:"pointer" }}
                                      tabIndex="-1"
                                      role="link"
                                      key={item.sku_s}
                                      href={tileUrls[item.sku_s] || "#"}
                                      onClick={()=>addAnalyticsForNavigateToPDP(item)}
                                    >
                                      <div
                                        className={`required-item-for-install-service required-item-reduce-padding`}
                                      >
                                        <div className="required-item-for-install-service__img">
                                          <img
                                            src={imgUrl}
                                            alt={productBrandName}
                                          />
                                        </div>
                                        <div className="required-item-for-install-service__title">
                                          {productBrandName || productName}
                                        </div>
                                        <div className="required-item-for-install-service__sku">
                                          {skuPrependName.toLowerCase() ===
                                          skuId.substring(0, 2).toLowerCase()
                                            ? skuId
                                            : `${
                                                skuPrependName
                                                  ? skuPrependName
                                                  : ""
                                              }${skuId}`}
                                        </div>
                                        <div className="required-item-for-install-service__price-quantity">
                                          <div className="required-item-for-install-service__price">
                                            {discountedPrice !== productPrice && (
                                            <>
                                            <div className="product-list-tile__mrp-section">
                                              <NumericFormat
                                                  value={parseFloat(discountedPrice ?? 0)}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  prefix={currency}
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                />
                                                </div>
                                              <div className="required-item-for-install-service__price-strike">
                                              <span className="product-list-tile__mrp">
                                                {"MRP "}
                                              </span>
                                                  <NumericFormat
                                                    value={parseFloat(productPrice)}
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    prefix={`${currency}`}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                  />
                                            </div>
                                            </>
                                          )}
                                          {discountedPrice===productPrice && (
                                            <div>
                                                  <NumericFormat
                                                    value={parseFloat(productPrice)}
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    prefix={`${currency}`}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                  />
                                            </div>
                                          )}
                                          </div>
                                        </div>
                                        
                                      </div>
                                    </a>
                                  </React.Fragment>
                                )
                              })
                            : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          </Slider>
        </div>
      </div>
    </>
  )
}

export default UpsellServicesMobile
